import React from 'react';
import StageItem from './StageItem';

interface Stage {
    id: number;
    title: string;
    description: string;
    status: 'completed' | 'pending' | 'current';
    path: string;
    url?: string | null;  // URL opcional para etapas especiales
}

interface StagesListProps {
    stages: Stage[];
    onStageClick: (stagePath: string) => void;
    verificationId?: number | null;
    verificationPaymentStatus?: string | null;
    isApplicant?: boolean;
    paymentUrl?: string | null;
    paymentManagedByFirm?: boolean;
}

const StagesList: React.FC<StagesListProps> = ({ stages, onStageClick, verificationId, verificationPaymentStatus, isApplicant, paymentUrl, paymentManagedByFirm }) => {
    return (
        <div className="stages-list-container">
            <div className="stages-list">
                {stages.map((stage, index) => (
                    <StageItem
                        key={stage.id}
                        stage={stage}
                        isLast={index === stages.length - 1}
                        onClick={() => onStageClick(stage.path)}
                        verificationId={verificationId}
                        verificationPaymentStatus={verificationPaymentStatus}
                        isApplicant={isApplicant}
                        paymentUrl={paymentUrl}
                        paymentManagedByFirm={paymentManagedByFirm}
                    />
                ))}
            </div>
        </div>
    );
};

export default StagesList;
